/*
 * The sign-in hint on "not found" (2026-10-26, ENHANCEMENTS S46).
 *
 * A private article is read only by its audiences, and for anybody else its
 * address answers exactly as an address nothing holds does - deliberately, so
 * that "not found" says nothing about whether the article exists. That leaves a
 * partner who was sent a link, and opened it signed out, looking at "not found"
 * with no idea that signing in would change the answer. So every "not found" a
 * SIGNED-OUT visitor meets says that some articles need sign-in, and offers to
 * sign in and come back to the same link - the owner's answer, 2026-10-26.
 *
 * It is the same on every "not found", for an address that holds a private
 * article and for one that holds nothing, which is what keeps it from being a
 * way to tell the two apart. Not shown to a signed-in reader (signing in again
 * would change nothing), while a sign-in is being restored, or where sign-in is
 * not configured on this deployment.
 */

import { useOptionalAuth } from '../auth/AuthProvider.js';
import { useMessages } from '../i18n/language.js';

export function SignInHint(): JSX.Element | null {
  const auth = useOptionalAuth();
  const t = useMessages();
  if (!auth || auth.signedIn || auth.restoringSession || auth.config?.auth.configured === false) return null;

  return (
    <div className="notice notice-info" role="note">
      <div className="notice-body">{t.account.signInHint}</div>
      <div className="notice-actions">
        <button type="button" className="button button-primary" onClick={auth.signIn}>
          {t.nav.signIn}
        </button>
      </div>
    </div>
  );
}
